import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import LacquerType from '../../types/api/lacquer-type'

export const lacquerTypesApi = createApi({
    reducerPath: 'lacquerTypesApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    // tagTypes: ['MaterialTypes'],
    endpoints: builder => ({
        getLacquerTypes: builder.query<Strapi<LacquerType>, EndpointQueryParameters | void>({
            query: getQuery('/lacquer-types'),
        }),
    }),
})

export const { useGetLacquerTypesQuery } = lacquerTypesApi
